import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PwaService } from './shared/services/pwa.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { DirectorLandingPageComponent } from './pages/director-landing-page/director-landing-page.component';
import { AdminDeviceSetupComponent } from './pages/admin-device-setup/admin-device-setup.component';
import { LoginComponent } from './pages/login/login.component';
import { StatusBarComponent } from './shared/status-bar/status-bar.component';
import { MatchCongratulationsComponent } from './pages/match-congratulations/match-congratulations.component';
import { AuthInterceptor } from './interceptors/auth-interceptor';


@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    DirectorLandingPageComponent,
    AdminDeviceSetupComponent,
    LoginComponent,
    StatusBarComponent,
    MatchCongratulationsComponent

  ],
  imports: 
  [
    BrowserModule,
    HttpClientModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule     
  ],
  providers: [
    PwaService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }      
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
